export default "__VITE_ASSET__BDWQZt9x__"